import { useEffect, useState } from "react";
import { useStableOkapiKy } from "../hooks/useStableOkapiKy";
import { fetchCurrentUser } from "../api/userService";
import { RoleEnum } from "../types/RoleEnum";
import { hasCachedActiveRoles, loadActiveRoles, readActiveRolesFromStorage, } from "./activeRolesLoader";
export var useActiveRoles = function () {
    var okapiKy = useStableOkapiKy();
    var _a = useState(readActiveRolesFromStorage), activeRoles = _a[0], setActiveRoles = _a[1];
    useEffect(function () {
        if (hasCachedActiveRoles()) {
            // Another hook instance (or earlier mount) already populated sessionStorage
            // between our useState lazy init and this effect. Sync local state so we
            // don't render with stale undefined.
            setActiveRoles(function (prev) {
                var _a;
                if (prev !== undefined)
                    return prev;
                return (_a = readActiveRolesFromStorage()) !== null && _a !== void 0 ? _a : [];
            });
            return undefined;
        }
        // One shared request for every instance on the page; a failure is cached
        // as "no roles", so nothing refetches on later renders.
        var cancelled = false;
        loadActiveRoles(function () { return fetchCurrentUser(okapiKy); }).then(function (roles) {
            if (!cancelled)
                setActiveRoles(roles);
        });
        return function () {
            cancelled = true;
        };
    }, [okapiKy]);
    return activeRoles;
};
var isSuperuser = function (activeRoles) {
    return activeRoles && activeRoles.includes(RoleEnum.SUPERUSER);
};
export var hasRole = function (activeRoles, requiredRole) {
    if (isSuperuser(activeRoles))
        return true;
    return activeRoles && activeRoles.includes(requiredRole);
};
export var hasAtLeastOneRole = function (activeRoles, requiredRole) {
    for (var _i = 0, requiredRole_1 = requiredRole; _i < requiredRole_1.length; _i++) {
        var role = requiredRole_1[_i];
        if (hasRole(activeRoles, role)) {
            return true;
        }
    }
    return false;
};
export var hasAtLeastOneRoleAndDontHaveOther = function (activeRoles, requiredRole, notRequiredRole) {
    return (hasAtLeastOneRole(activeRoles, requiredRole) &&
        !hasRole(activeRoles, notRequiredRole));
};
export var hasExactlyRoles = function (activeRoles, exactRoles) {
    var norm = function (r) {
        return String(r !== null && r !== void 0 ? r : "")
            .trim()
            .toUpperCase();
    };
    var act = (activeRoles !== null && activeRoles !== void 0 ? activeRoles : []).map(norm);
    var ex = (exactRoles !== null && exactRoles !== void 0 ? exactRoles : []).map(norm);
    if (act.length !== ex.length)
        return false;
    return ex.every(function (r) { return act.includes(r); });
};
